module.exports = __webpack_public_path__ + "static/media/sunglass-covered.b6af0557.svg";